import {
  USER_SIGNOUT,
  MOTS_FAIL,
  MOTS_REQUEST,
  MOTS_SUCCESS,
  MOTS_REMOVE_ITEM,
  MOT_LECON_SELECTED,
  MOT_LECON_UNSELECTED,
  MOT_SELECTED,
  MOT_UNSELECTED,
  MOT_SELECTED_UPDATE,
  MOT_SAVE,
  MOT_RESET,
  MOT_CONFIG_REMOVE_ITEM,
  MOT_CONFIG_SELECTED,
  MOT_CLEAN,
  MOT_LECON_SELECTED_BY_MOT,
  MOT_LECON_SELECT_UNSELECT_ALL,
  MOTS_BANK_REQUEST,
  MOTS_BANK_SUCCESS,
  MOTS_BANK_CLEAN,
  MOT_UPDATE_BANK_WORD,
  MOT_CREATE_BANK_WORD,
  MOT_PRINT_LIST,
  MOT_FONT,
  MOTS_FOCUS,
  MOT_ISFOCUS,
  MOT_ONLYFOCUS_BANK_WORD
} from "../actionTypes";

function motReducers(
  state = {
    focus: [],
    isFocus: false,
    mots: [], lecons: [], motSelected: {}, configSelected: {}, bank: [], motToPrints: [], font: "no"
  },
  action
) {
  switch (action.type) {
    case USER_SIGNOUT:
      return {
        focus: [],
        mots: [],
        lecons: [],
        motSelected: {},
        configSelected: {},
        loading: false,
        loadingBank: false,
        bank: [],
        motToPrints: [],
        font: "no",
        isFocus: false
      };
    case MOT_ISFOCUS:
      return { ...state, isFocus: action.payload };
    case MOTS_BANK_REQUEST:
      return { ...state, loadingBank: true };
    case MOTS_BANK_SUCCESS:
      return { ...state, loadingBank: false, bank: [...state.bank, ...action.payload] };
    case MOTS_BANK_CLEAN:
      return { ...state, loadingBank: false, bank: action.payload };
    case MOTS_REQUEST:
      return { ...state, loading: true };
    case MOTS_SUCCESS:
      return { ...state, loading: false, mots: action.payload };
    case MOTS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case MOTS_REMOVE_ITEM:
      return {
        ...state,
        mots: state.mots.filter((x) => x._id !== action.payload),
        motSelected: {},
      };
    case MOT_LECON_SELECTED:
      let leconToSelectIsThere = state.lecons.find(
        (x) => x === action.payload._id
      );
      if (!leconToSelectIsThere) {
        return {
          ...state,
          loading: false,
          mots: [...state.mots, ...action.payload.data],
          lecons: [...state.lecons, action.payload._id],
        };
      }
      return state;
    case MOT_LECON_SELECTED_BY_MOT:
      return {
        ...state,
        mots: action.payload.data,
        lecons: action.payload.ids,
      };
    case MOT_LECON_UNSELECTED:
      let leconToUnselectIsThere = state.lecons.find(
        (x) => x === action.payload._id
      );
      if (leconToUnselectIsThere) {
        return {
          ...state,
          mots: action.payload.data,
          lecons: state.lecons.filter((x) => x !== action.payload._id)
        };
      }
      return state;
    case MOT_SELECTED:
      return { ...state, motSelected: action.payload };
    case MOT_UNSELECTED:
      return { ...state, motSelected: action.payload };
    case MOT_SELECTED_UPDATE:
      return { ...state, motSelected: action.payload };
    case MOT_SAVE:
      return { ...state, motSelected: action.payload };
    case MOT_RESET:
      return { ...state, motSelected: action.payload };
    case MOT_FONT:
      return { ...state, font: action.payload };
    case MOT_CONFIG_REMOVE_ITEM:
      let motSelected = state.motSelected;
      if (motSelected) {
        if (motSelected.mot) {
          motSelected.mot = motSelected.mot.filter(
            (x) => x.config !== action.payload
          );
        }
        return { ...state, motSelected: motSelected };
      }
    case MOT_CONFIG_SELECTED:
      return { ...state, configSelected: action.payload };
    case MOT_CLEAN:
      return { ...state, mots: [], lecons: [], motSelected: {}, configSelected: {}, bank: [], motToPrints: [] };
    case MOT_LECON_SELECT_UNSELECT_ALL:
      return {
        ...state,
        mots: action.payload.data,
        lecons: action.payload.ids,
      };
    case MOT_ONLYFOCUS_BANK_WORD:
      return { ...state, mots: action.payload.focus, bank: action.payload.focus};
    case MOT_CREATE_BANK_WORD:
      return { ...state, mots: [...state.mots, action.payload.mot], bank: [...state.bank, action.payload.wordBank] };
    case MOT_UPDATE_BANK_WORD:
      let newState = state.mots.map(o => { return o._id === action.payload.mot._id ? action.payload.mot : o });
      return { ...state, mots: newState, bank: [...state.bank.filter(o => o._id !== action.payload.wordBank._id), action.payload.wordBank] };
    case MOT_PRINT_LIST:
      return { ...state, motToPrints: action.payload };
    case MOTS_FOCUS:
      return { ...state, focus: action.payload };
    default:
      return state;
  }
}

export { motReducers };
